import { useState } from "react";
import { Label } from "expano-components";
import { Statuses, ActionsGroup, Select } from "components";
import { productExport } from "actions/product_group/export";
import SalesStatusModal from "./SalesStatusModal";
import sales_status_options from "../const/sales_status_options";

const ProductExportLine = (data) => {
  const [is_open_sale_status_modal, handleOpenSaleStatusModal] =
    useState(false);

  const [sales_status, setSalesStatus] = useState(null);

  return (
    <tr key={data.id}>
      <td>
        <Label
          left={{
            color: data?.channel?.shop?.label_color,
            text: data?.channel?.shop?.label_text,
          }}
          right={{
            color: `#${data?.channel?.platform?.label_color}`,
            text: data?.channel?.platform?.label_text,
          }}
          type="double"
        />
        <span>{data.channel?.identifier}</span>
      </td>
      <td>
        {!!data.offer_url ? (
          <a
            className="text-link"
            target="_blank"
            rel="noopener noreferrer"
            href={data.offer_url}
          >
            {data.offer_url}
          </a>
        ) : (
          "-"
        )}
      </td>
      <td>
        {!!data.offer_url ? (
          <Statuses text="Aktywna" status="success" />
        ) : (
          <Statuses text="Nie dodano" status="default" />
        )}
      </td>
      <td>
        <Select
          searchable={false}
          value={
            sales_status_options.find(
              ({ value }) => value === data.sales_status
            ) || {}
          }
          options={sales_status_options}
          handleChange={(value) => {
            setSalesStatus(value);
            handleOpenSaleStatusModal(true);
          }}
        />
      </td>
      <td>
        <ActionsGroup
          options={[
            {
              label:
                data.export_type === "products"
                  ? "Eksportuj produkt"
                  : "Eksportuj aliasy produktowe",
              icon: null,
              onClick: () => productExport(data.id),
            },
          ]}
        />
      </td>
      {is_open_sale_status_modal && (
        <SalesStatusModal
          product={data?.product}
          id={data?.id}
          refetch={data.refetch}
          sales_status={sales_status}
          handleClose={() => {
            handleOpenSaleStatusModal(false);
            setSalesStatus(null);
          }}
        />
      )}
    </tr>
  );
};

export default ProductExportLine;
